import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { pageState } from '../../../src/atoms/PageAtom'

import HomeNews from './section/news'
// import HomeRanking from './section/ranking'
import HomeArtists from './section/artists'
import HomeNfts from './section/nfts'
import HomeGeneratives from './section/generatives'
import HomePickupMusics from './section/pickupMusics'
// import HomeVtubers from './section/vtubers'

type Props = {
  web3: Web3
}

function Home(props: Props) {
  const { t } = useTranslation()
  const [, setPage] = useRecoilState(pageState)

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title =
      '音楽NFTプラットフォーム | Sound Desert（サウンドデザート）'
  }, [])

  return (
    <div className="page-home">
      <div className="container">
        <HomePickupMusics />

        <div className="sections">
          <section className="section">
            <div className="ttl-flex">
              <h2 className="section-ttl">最近投稿された音楽NFT</h2>
            </div>
            <HomeNfts genreId="recent" />
          </section>

          <section className="section">
            <div className="ttl-flex">
              <h2 className="section-ttl">チル</h2>
              <button
                className="more-button"
                onClick={() => setPage('nft?genre=chill')}
              >
                {t('parts.moreButton.text')}
              </button>
            </div>
            <HomeNfts genreId="chill" />
          </section>

          {/* <HomeVtubers web3={props.web3} /> */}

          <section className="section">
            <div className="ttl-flex">
              <h2 className="section-ttl">ポップス</h2>
              <button
                className="more-button"
                onClick={() => setPage('nft?genre=pops')}
              >
                {t('parts.moreButton.text')}
              </button>
            </div>
            <HomeNfts genreId="pops" />
          </section>

          <HomeNews />

          <section className="section">
            <div className="ttl-flex">
              <h2 className="section-ttl">ヒップホップ</h2>
              <button
                className="more-button"
                onClick={() => setPage('nft?genre=hiphop')}
              >
                {t('parts.moreButton.text')}
              </button>
            </div>
            <HomeNfts genreId="hiphop" />
          </section>

          {/* イチオシのジェネラティブ */}
          <HomeGeneratives web3={props.web3} />

          <section className="section">
            <div className="ttl-flex">
              <h2 className="section-ttl">ロック</h2>
              <button
                className="more-button"
                onClick={() => setPage('nft?genre=rock')}
              >
                {t('parts.moreButton.text')}
              </button>
            </div>
            <HomeNfts genreId="rock" />
          </section>

          <section className="section">
            <div className="ttl-flex">
              <h2 className="section-ttl">Artists</h2>
            </div>
            <HomeArtists />

            <button
              className="more-btn wide bk round"
              onClick={() => setPage('artists')}
            >
              {t('parts.moreButton.prefix.artist')}
              {t('parts.moreButton.text')}
            </button>
          </section>

          {/* <section className="section">
            <h2 className="section-ttl">OpenSea Trend</h2>
            <HomeRanking />
          </section> */}
        </div>
      </div>
    </div>
  )
}

export default Home
